'use strict';

/* eslint max-lines-per-function: 0 */
/* eslint quote-props: 0 */

var ids = require('./ids'),
    links = require('./links');


module.exports = function ( data ) {
    var gettext = links.gettext,
        renders = links.api.renders,
        getter = links.api.getters.environment,
        saver = links.api.savers.environment,
        sections, options;

    sections = [
        {
            id: ids.pppoe,
            name: gettext('PPPoE'),
            description: gettext('Enable / Disable PPPoE'),
            icon: 'theme-icon-lan',
            parent: ids.base,
            onsave: function () {
                gSTB.ServiceControl('pppoe', 'restart');
            }
        }
    ];

    options = [
        {
            id: ids.pppoeDnsElement1,
            name: gettext('Enable'),
            description: '',
            icon: 'theme-icon-lan',
            render: renders.toggle,
            saveImmediate: false,
            environment: {
                'pppoe_enabled': false
            },
            prepareForRender: function ( env, callback ) {
                callback(env['pppoe_enabled']);
            },
            prepareForSave: function ( value, callback ) {
                this.environment['pppoe_enabled'] = value;
                callback();
            },
            getter: getter,
            saver: saver,
            parent: ids.pppoe
        },
        {
            id: ids.pppoeDnsElement2,
            name: gettext('Login'),
            description: '',
            icon: '',
            render: renders.input,
            config: {
                title: gettext('Enter login'),
                type: 'text',
                mode: 'qwerty'
            },
            saveImmediate: false,
            environment: {
                'pppoe_login': ''
            },
            prepareForRender: function ( env, callback ) {
                this.config.value = env['pppoe_login'];
                callback();
            },
            prepareForSave: function ( value, callback ) {
                this.environment['pppoe_login'] = value;
                callback();
            },
            getter: getter,
            saver: saver,
            parent: ids.pppoe
        },
        {
            id: ids.pppoeDnsElement3,
            name: gettext('Password'),
            description: '',
            icon: '',
            render: renders.input,
            config: {
                title: gettext('Enter password'),
                type: 'password',
                mode: 'qwerty'
            },
            saveImmediate: false,
            environment: {
                'pppoe_pwd': ''
            },
            prepareForRender: function ( env, callback ) {
                this.config.value = env['pppoe_pwd'];
                callback();
            },
            prepareForSave: function ( value, callback ) {
                this.environment['pppoe_pwd'] = value;
                callback();
            },
            getter: getter,
            saver: saver,
            parent: ids.pppoe
        },
        {
            id: ids.pppoeDnsElement4,
            name: gettext('DNS'),
            description: '',
            icon: '',
            render: renders.input,
            advanced: true,
            config: {
                title: gettext('Enter DNS'),
                type: 'password',
                mode: 'number'
            },
            saveImmediate: false,
            environment: {
                'pppoe_dns1': ''
            },
            prepareForRender: function ( env, callback ) {
                this.config.value = env['pppoe_dns1'];
                callback();
            },
            prepareForSave: function ( value, callback ) {
                this.environment['pppoe_dns1'] = value;
                callback();
            },
            getter: getter,
            saver: saver,
            parent: ids.pppoe
        }
    ];

    sections.forEach( function ( item ) {
        data.sections.push(item);
    });

    options.forEach(function ( item ) {
        data.options.push(item);
    });
};
